import React from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import colors from '@app/constants/colors';
import RouterConstants from '@app/constants/router';
import { userLogout } from '@app/actions/userActions';

const LoginHeaderItem = ({ isLoggedIn, userLogout }) => (
  <LoginHeaderItemContainer>
    {
      isLoggedIn
        ? (
          <LogoutLink to={RouterConstants.HOME} onClick={userLogout}>
            <FormattedMessage id="header.logout" />
          </LogoutLink>
        )
        : (
          <React.Fragment>
            <FormattedMessage id="header.alreadyMember" />
            <LoginLink to={RouterConstants.SIGN_IN}>
              <FormattedMessage id="header.login" />
            </LoginLink>
          </React.Fragment>
        )
    }
  </LoginHeaderItemContainer>
);

LoginHeaderItem.propTypes = {
  isLoggedIn: PropTypes.bool.isRequired,
  userLogout: PropTypes.func.isRequired,
};

const mapStateToProps = ({ user: { isLoggedIn } }) => ({
  isLoggedIn,
});

export default connect(mapStateToProps, { userLogout })(LoginHeaderItem);

const LoginHeaderItemContainer = styled.div`
  font-size: 25px;
  
  @media (max-width: 1149px) {
  font-size: 23px;
  }
  @media (max-width: 800px) {
    font-size: 20px;
  }
  @media (max-width: 449px) {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    font-size: 15px;
  }
`;

const LoginLink = styled(Link)`
  color: ${colors.RED_ORANGE};
  margin: 0 10px;
`;

const LogoutLink = styled(Link)`
  color: ${colors.CERULEAN};
`;
